var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "message-record-container",
    on: {
      "click": _vm.openMergeDetail
    }
  }, [_c('div', {
    staticClass: "record-title"
  }, [_vm._v(" " + _vm._s(_vm.props.renderData.title) + " ")]), _c('div', {
    staticClass: "record-abstract-container"
  }, _vm._l(_vm.props.renderData.abstractList.slice(0, 7), function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "record-abstract-item"
    }, [_vm._v(" " + _vm._s(_vm.transformTextWithKeysToEmojiNames(item)) + " ")]);
  }), 0), _c('div', {
    staticClass: "record-footer"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.聊天记录")) + " ")])]), !_vm.props.disabled && _vm.isPC ? _c('Overlay', {
    attrs: {
      "visible": _vm.isMessageListVisible
    },
    on: {
      "onOverlayClick": function ($event) {
        _vm.isMessageListVisible = false;
      }
    }
  }, [_c('SimpleMessageList', {
    attrs: {
      "isMounted": _vm.isMessageListVisible,
      "renderData": _vm.props.renderData,
      "messageID": _vm.props.messageItem.ID
    },
    on: {
      "closeOverlay": _vm.closeMergeDetail
    }
  })], 1) : !_vm.props.disabled && _vm.isH5 ? _c('Drawer', {
    attrs: {
      "visible": _vm.isMessageListVisible,
      "isFullScreen": true,
      "overlayColor": 'transparent',
      "popDirection": 'right'
    }
  }, [_c('SimpleMessageList', {
    attrs: {
      "isMounted": _vm.isMessageListVisible,
      "renderData": _vm.props.renderData,
      "messageID": _vm.props.messageItem.ID
    },
    on: {
      "closeOverlay": _vm.closeMergeDetail
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }